import React, { useState, useEffect, useContext, memo } from "react";
import { Button, Box, Icon, Typography } from "@mui/material";
import { AuthContext } from "src/utils/AuthContext.js";
import TimelineCreatorDialog from "./dialogs/TimelineCreatorDialog.js";

function CreateAutomatedEventButton({
  calendars,
  handle,
  selectedCalendar,
  setSelectedCalendar,
  openEditEventDialog,
  setOpenEditEventDialog,
}) {
  const { user } = useContext(AuthContext);
  const [openTimelineCreatorDialog, setOpenTimelineCreatorDialog] =
    useState(false);

  // Handle scroll-based bottom tray for creator
  useEffect(() => {
    const handleShowTimelineCreatorDialog = () => {
      const isTimelinePage = window.location.pathname.includes(handle);
      if (isTimelinePage && user) {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        // Show bottom tray when scrolled down 200px or more
        // and not at the very bottom of the page
        const shouldShow =
          scrollY > 200 && scrollY < documentHeight - windowHeight - 100;

        if (shouldShow && !openTimelineCreatorDialog) {
          setOpenTimelineCreatorDialog(true);
        } else if (!shouldShow && openTimelineCreatorDialog) {
          setOpenTimelineCreatorDialog(false);
        }
      }
      window.addEventListener("scroll", handleShowTimelineCreatorDialog, {
        once: true,
      });
    };

    window.addEventListener("scroll", handleShowTimelineCreatorDialog, {
      once: true,
    });
    return () => {
      window.removeEventListener("scroll", handleShowTimelineCreatorDialog);
    };
  }, [handle, openTimelineCreatorDialog, user]);

  return (
    <>
      <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          sx={{
            textTransform: "none",
            fontSize: "inherit",
            display: "block",
            width: "fit-content",
            backgroundColor: "#000000",
            color: "#ffffff",
            mt: 3,
            mb: 1,
          }}
          onClick={() => {
            setOpenEditEventDialog(true);
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <Icon
              baseClassName="material-symbols-outlined"
              fontSize="small"
              sx={{
                color: "#ffffff",
              }}
            >
              add
            </Icon>
            <Typography variant="subtitle1" color="#ffffff">
              CREATE EVENT
            </Typography>
          </Box>
        </Button>
      </Box>

      {openTimelineCreatorDialog && (
        <TimelineCreatorDialog
          open={openTimelineCreatorDialog}
          handleClose={() => setOpenTimelineCreatorDialog(false)}
          calendars={calendars}
          handle={handle}
          selectedCalendar={selectedCalendar}
          setSelectedCalendar={setSelectedCalendar}
          openEditEventDialog={openEditEventDialog}
          setOpenEditEventDialog={setOpenEditEventDialog}
        />
      )}
    </>
  );
}

export default memo(CreateAutomatedEventButton);
